import { useCallback } from 'react'
import { updateThreadTitle } from '@/services/chat/threadsApi'

/** @param {{ setThreads: Function }} m */
export function useRenameThreadAction(m) {
  const { setThreads } = m
  const handleRenameThread = useCallback(
    (id, newTitle) => {
      const trimmed = newTitle.trim()
      if (!trimmed) return
      setThreads((prev) => {
        const idx = prev.findIndex((t) => t.id === id)
        if (idx >= 0) {
          return prev.map((thread) => (thread.id === id ? { ...thread, title: trimmed } : thread))
        }
        return [{ id, title: trimmed }, ...prev]
      })
      void updateThreadTitle(id, trimmed).catch(() => {})
    },
    [setThreads],
  )
  return { handleRenameThread }
}
